module.exports = "/images/home-w.svg?82a3fd26beb6f2969a30098ff61fe440";